import { useState, useEffect, useRef } from 'react'
import { getFloorPlans } from 'store/actions/floorPlanActions'

const useGetFloorPlans = (id = '') => {
  const mountedRef = useRef(true)
  const [floorPlans, setFloorPlans] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getData(id)
    return () => {
      mountedRef.current = false
    }
  }, [])

  const getData = async (id = '') => {
    setLoading(true)
    try {
      const data = await getFloorPlans(id || '')
      if (!mountedRef.current) return null
      setFloorPlans(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  return { loading, floorPlans, refetch: () => getData(id) }
}

export default useGetFloorPlans
